/* unplugin-vue-components disabled */import script from "./Notification.vue?vue&type=script&setup=true&lang=js"
export * from "./Notification.vue?vue&type=script&setup=true&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=ef01045c&scoped=true&lang=css"

import exportComponent from "D:\\星网代码\\2018-05-18 路特利\\2022-02-23需求\\DM.LtlApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef01045c"]])

export default __exports__